import { combineReducers } from 'redux';
import steps from './bpm-steps.reducers';
import { connectRouter } from 'connected-react-router';
import { History } from 'history';

const reducers: CMx.HistoricalReducer = (history: History) => {
  return combineReducers({
    steps,
    router: connectRouter(history)
  });
};

export default reducers;
